import { css } from "styled-components";
import FONTS, { FontsType } from "../constants/fonts";
import MixinProps from "../types/mixin";
import FontSize from "../constants/fontSize";
import { Breakpoint } from "../constants/breakpoint";
import { TypographyProps } from "../components/Typography";

export const fontWeightMixin = css<MixinProps>`
    font-family: ${({ weight }) =>
        weight && FONTS[weight.toUpperCase() as FontsType]};
`;
export const getCommonFontStyleMixin = (
    props: Pick<TypographyProps, "size" | "mSize" | "weight">,
) => {
    const { size, mSize, weight } = props;
    return css`
        ${css({
            ...(weight && {
                fontFamily: FONTS[weight.toUpperCase() as FontsType],
            }),
            ...(size && {
                fontSize: `${FontSize[size]}rem`,
            }),
        })}

        @media (max-width: ${Breakpoint.mobileBreakpointMaxWidth}) {
            ${css({
                ...(mSize && {
                    fontSize: `${FontSize[mSize]}rem`,
                }),
            })}
        }
    `;
};
